import React, { useEffect } from 'react'
import classes from './HomePackage.module.css'
import validator from 'validator'

interface IPackageProps{
    plan: {
       endDate: string,
       all: string | number,
       used: string | number,
       title: string
    } | null
}

const HomePackage: React.FC<IPackageProps> = (props)=>{


    useEffect(()=>{
        
    },[])
        
    if(props.plan)
    return (
        <React.Fragment>
            <div className={classes.myPackage}>
                <div className={true ? [classes.pContainer].join(' ') : classes.pContainer}>
                    <p style={{
                        margin: 0, 
                        padding: 0, 
                        marginRight: 6, 
                        fontWeight: 'bold', 
                        fontSize: 20,
                        color: validator.isBefore(props.plan.endDate.toString()) ? 'darkred' : '#000'
                        }}>
                        {props.plan?.title}
                    </p>
                    {validator.isBefore(props.plan.endDate.toString()) ? (
                    <p style={{margin: 0, padding: 0, fontSize: 18, color: 'darkred'}}>
                        تم إنتهاء الباقة
                    </p>) : (
                        <p style={{margin: 0, padding: 0, fontSize: 18}}>
                        أنت الآن علي الباقة
                        </p>
                    )}
                </div>
            </div>
                <div className={classes.dContainer}>
                    <div className={classes.whiteContainer}>
                        <div className={classes.pContainer}>
                            <p style={{
                                margin: 0, 
                                padding: 0, 
                                marginRight: 6, 
                                fontWeight: 'bold', 
                                color: validator.isBefore(props.plan.endDate.toString()) ? 'red' : '#000'
                                }}
                            >
                                {props.plan?.endDate.split('T')[0]}
                            </p>
                           <p style={{margin: 0, padding: 0, fontSize: 12}}>
                            :موعد الإنتهاء
                            </p>
                            
                        </div>
                        <div className={classes.pContainer}>
                            <p style={{margin: 0, padding: 0, marginRight: 6, fontWeight: 'bold'}}>
                                {props.plan?.all === 'غير محدود' ? '' : `${props.plan?.all} / `}{props.plan?.used}
                            </p>
                            <p style={{margin: 0, padding: 0, fontSize: 12}}>
                                :وظائف
                            </p>
                        </div>
                    </div>
                </div>
        </React.Fragment>
    )
    else
    return(
        <NotActive />
    )
} 


export const NotActive: React.FC = ()=>{

    return(
          <React.Fragment>
          <div className={classes.myPackage}>
              <div className={true ? [classes.pContainer].join(' ') : classes.pContainer}>
                  <p style={{margin: 0, padding: 0, fontSize: 18, color: 'darkred'}}>
                      تتم الآن مراجعة حسابك 
                  </p>
              </div>
          </div>
          </React.Fragment>
    )
  }

export default HomePackage